import script from "./BalProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalProgressBar.vue?vue&type=script&setup=true&lang=ts"

import "./BalProgressBar.vue?vue&type=style&index=0&id=2f37ac7c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f37ac7c"]])

export default __exports__